/*
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-07-21 14:39:56
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2024-06-19 11:32:50
 */
// import Router from 'vue-router'
import router, { resetRouter } from './router'
import store from './store'
// import i18n from './utils/i18n'
import { setRoutes } from '@/utils/routes'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style

NProgress.configure({
  easing: 'ease', // 动画方式
  speed: 500, // 递增进度条的速度
  showSpinner: false, // 是否显示加载ico
  trickleSpeed: 200, // 自动递增间隔
  minimum: 0.3 // 初始化时的最小百分比
})

// NProgress.configure({ showSpinner: false }) // NProgress Configuration
let isToken = true
router.beforeEach(async (to, from, next) => {
  // start progress bar
  const language = store.getters.language
  // const service = store.getters.service
  const i18nLocale = store.getters.i18nLocale
  NProgress.start()
  /* 路由发生变化修改页面title */
  // console.log(to)
  if (to.name) {
    document.title = to.name.replace(/<sup>&#174;<\/sup>/g, '®').replace(/<sup>&trade;<\/sup>/g, '™')
  }
  // console.log(to.path, i18n.locale, language, isToken)
  // if (to.path.split('/').findIndex(item => item === 'innovative') !== -1 && language !== 'zh' && service !== 'pc') {
  //   console.log(22222)
  //   // 页面每次打开返回顶部位置
  //   // chrome
  //   document.body.scrollTop = 0
  //   // firefox
  //   document.documentElement.scrollTop = 0
  //   // safari
  //   window.pageYOffset = 0
  // }
  // 页面每次打开返回顶部位置
  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  window.pageYOffset = 0
  if (isToken) {
    const accessRoutes = await store.dispatch('permission/generateRoutes', language)
    resetRouter()
    router.options.routes = store.getters.permission_routes
    // console.log(store.getters.permission_routes)
    // router.matcher = new Router().matcher
    // router.addRoutes(accessRoutes)
    setRoutes(accessRoutes)
    isToken = false // 将isToken赋为 false ，否则会一直循环，崩溃
    if ((to.path === '/en' || to.path.indexOf('/en/') !== -1) && language === 'zh') {
      next('/')
    } else {
      if (language !== i18nLocale) {
        const indexTo = {
          fullPath: '/',
          path: '/',
          hash: '',
          matched: [],
          meta: {},
          name: null,
          params: {},
          query: {}
        }
        next({ ...indexTo, replace: true })
      } else {
        next({ ...to, replace: true })
      }
    }
  } else {
    store.dispatch('app/setI18nLocale', language)
    if (language !== i18nLocale) {
      next('/')
    } else {
      next()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
